module.exports = __webpack_public_path__ + "static/media/carlton.6bd1f54e.svg";